import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useConfig } from '../context/ConfigContext';

export default function SmsPolicy() {
  const { contact } = useConfig();
  const today = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
  const company = contact.companyName || 'Xpertpests Solutions';
  const phone = contact.phone1 || '562-215-8002';
  const email = contact.email || 'info@xpertpestssolutions.com';

  return (
    <div className="bg-white" data-testid="sms-policy-page">
      <Header />
      <section className="max-w-3xl mx-auto px-6 py-16">
        <p className="text-[#8BC53F] font-bold tracking-widest text-sm mb-3">LEGAL</p>
        <h1 className="text-4xl md:text-5xl font-extrabold tracking-tight text-slate-900">SMS / Text Messaging Terms &amp; Opt-In Policy</h1>
        <p className="text-slate-500 mt-2">Effective {today}</p>

        <div className="mt-8 space-y-6 text-slate-700 leading-relaxed">
          <p>This policy explains how <b>{company}</b> (“we”, “us”, “our”) sends text (SMS/MMS) messages and how you consent to and manage those messages. By providing your mobile phone number and opting in, you agree to these terms.</p>

          <h2 className="text-2xl font-bold text-slate-900 mt-8">1. Program Description</h2>
          <p>{company} sends service-related text messages to customers who have opted in. Messages may include: appointment scheduling and reminders, “technician on the way” notifications, service completion updates, invoice and payment reminders, and requests for feedback or reviews.</p>

          <h2 className="text-2xl font-bold text-slate-900 mt-8">2. How You Opt In (Consent)</h2>
          <p>You provide express consent to receive SMS messages from {company} in one of the following ways:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>By entering your mobile number and checking the SMS consent box on our service-request, booking, or customer intake form;</li>
            <li>By providing your mobile number in writing or verbally to our staff and agreeing to receive text updates about your service; or</li>
            <li>By texting us first to start a conversation.</li>
          </ul>
          <p className="bg-slate-50 border border-slate-200 rounded-lg p-4 text-sm">
            <b>Sample opt-in language we use:</b> “I agree to receive recurring automated service text messages (e.g., appointment reminders, on-the-way alerts, and payment reminders) from {company} at the phone number provided. Consent is not a condition of purchase. Message frequency varies. Message &amp; data rates may apply. Reply STOP to cancel or HELP for help.”
          </p>
          <p>Consent is <b>not</b> a condition of purchasing any goods or services.</p>

          <h2 className="text-2xl font-bold text-slate-900 mt-8">3. Message Frequency</h2>
          <p>Message frequency varies and depends on your service activity (for example, how many appointments or invoices you have).</p>

          <h2 className="text-2xl font-bold text-slate-900 mt-8">4. Cost</h2>
          <p>Message and data rates may apply, charged by your mobile carrier according to your plan. {company} does not charge for the messages themselves.</p>

          <h2 className="text-2xl font-bold text-slate-900 mt-8">5. Opt-Out</h2>
          <p>You can cancel the SMS service at any time by replying <b>STOP</b> to any message. After you send STOP, we will send a confirmation message and then stop sending SMS messages. You may opt back in at any time by replying <b>START</b> or by contacting us.</p>

          <h2 className="text-2xl font-bold text-slate-900 mt-8">6. Help</h2>
          <p>For help, reply <b>HELP</b> to any message, or contact us at <a href={`tel:${phone}`} className="text-[#8BC53F] font-semibold underline">{phone}</a> or <a href={`mailto:${email}`} className="text-[#8BC53F] font-semibold underline">{email}</a>.</p>

          <h2 className="text-2xl font-bold text-slate-900 mt-8">7. Privacy</h2>
          <p>We respect your privacy. <b>No mobile information will be shared with third parties or affiliates for marketing or promotional purposes.</b> Information sharing to subcontractors in support services, such as customer service or our SMS delivery provider, is permitted only to operate the messaging program. All the above categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties. See our <Link to="/privacy" className="text-[#8BC53F] font-semibold underline">Privacy Policy</Link> for full details.</p>

          <h2 className="text-2xl font-bold text-slate-900 mt-8">8. Supported Carriers</h2>
          <p>Carriers are not liable for delayed or undelivered messages. Supported carriers may change without notice.</p>

          <h2 className="text-2xl font-bold text-slate-900 mt-8">9. Contact</h2>
          <p>{company}<br />{contact.address || 'P.O. Box 4462'}<br />{phone}<br /><a href={`mailto:${email}`} className="text-[#8BC53F] font-semibold underline">{email}</a></p>

          <div className="mt-10 pt-6 border-t border-slate-200 text-sm text-slate-500">
            See also our <Link to="/privacy" className="text-[#8BC53F] font-semibold underline">Privacy Policy</Link> and <Link to="/terms" className="text-[#8BC53F] font-semibold underline">Terms of Service</Link>.
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
